import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { dataPipelines } from '../../../../api/coreData'
import ScoreRing from '../dataviz/ScoreRing'

const useStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
})

function RiskScoreView (props) {
  const styles = useStyles()
  const { data, isLoading } = dataPipelines.useExecuteDataPipeline({
    pipelineCode: 'orion-risk-data',
    variables: {
      filters: {
        requestType: 'statistics',
        levelId: props.clientId
      }
    }
  })

  if (isLoading) return null

  return (
    <div className={styles.container}>
      <ScoreRing
        score={data?.data?.riskScore}
        chartOptions={props.chartOptions}
        ringSeriesOptions={props.ringSeriesOptions}
        pointSeriesOptions={props.pointSeriesOptions}
      />
    </div>
  )
}

RiskScoreView.propTypes = {
  clientId: PropTypes.number,
  chartOptions: PropTypes.object,
  ringSeriesOptions: PropTypes.object,
  pointSeriesOptions: PropTypes.object
}

RiskScoreView.defaultProps = {
  chartOptions: {
    width: 150,
    height: 150
  },
  ringSeriesOptions: {

  },
  pointSeriesOptions: {

  }
}

export default RiskScoreView
